import supplierContactServices from '../../../services/provider/supplier-contacts'
import SupplierContactModel from './SupplierContactModel'
import { SITE_STATUS } from '../../../misc/commons'
import SupplierContactImport from './SupplierContactImport'
import ResponseModal from './ResponseModal'
import ErrorModal from '../../share/ErrorModal'
import { SUPLLIER_EMAIL_STATUS, EMAIL_STATUS } from '../../../misc/commons'
import { AG_GridCustomizedTableHeaders_Key, txtFormatter, trimWhiteSpaces } from '../../../misc/tableHeaders'
import { OUTPUT_SHORTDATE_FORMAT } from '../../../misc/commons'
import { _findObj, toLocal, } from '../../../misc/genericFunctions'
import { getOrgId } from '../../../misc/auth'
import HeaderCheckBox from '../../../components/noti/TableGrid/CustomComponent/headerCheckBox.vue'
export default {
    components: {
        SupplierContactModel,
        SupplierContactImport,
        ResponseModal,
        ErrorModal,
        HeaderCheckBox
    },
    data() {
        return {
            total: 0,
            items: [],
            supplierContactedIds: [],
            organization_id: null,
            e: null,
            searchQuery: { pageNumber: 1, pageSize: 500, sort: null, colId: null, globalSearch: null },
            emailStatus: EMAIL_STATUS,
            supplier_status: SITE_STATUS,
            supplierEmailStatus: SUPLLIER_EMAIL_STATUS,
            supplierContactModelKey: 0,
            suppliercontactImportKey: 0,
            respModalKey: 0,
            isCheckAll: false,
            isEnable: false,
            isCheckboxEnable: false,
            Listitems: [],
            suppliercontactIds: [],
            autonotifychecked: false,
            errorModalKey: 0,
            globalSearchText: '',
            searchTimer: null,
            search: {
                supplier_id: null,
                full_name: null,
                title: null,
                email: null,
                phone_number: null,
                status: null,
                responsestatus: null,
                supplierName: null,
                globalSearch: null,
            },
            columnDefs: [],
            gridOptions: {
                rowSelection: 'multiple',
                rowModelType: 'serverSide',
                suppressRowClickSelection: true,
                enableRangeSelection: true,
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                onSelectionChanged: this.onSelectionChanged,
                getContextMenuItems: this.getContextMenuItems,
            },
            rowModelType: 'serverSide',
            defaultColDef: {
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                flex: 1,
            },
            rowData: [],
            gridApi: null,
            columnApi: null,
            table_Connection_Data: this.$store.state.CustomizedHeaders?.filter(s => s.userId == this.$store.state.user.id)[0] || { Provider_Login: {} },
        }
    },
    beforeMount() {
        this.columnDefs = [
            {
                minWidth: 60,
                field: 'multichoice',
                type: 'rightColumn',
                hide: false,
                headerName: '',
                suppressMenu: true,
                suppressSorting: true,
                editable: true,
                suppressColumnsToolPanel: true,
                headerComponent: 'HeaderCheckBox',
                HeaderChangeCallback: this.headerChangeCallback,
                suppressMovable: true,
                checkboxSelection: function (params) { return params.columnApi.getRowGroupColumns().length === 0},
                headerCheckboxSelection: function (params) { return params.columnApi.getRowGroupColumns().length === 0},
            },
            {
                minWidth: 150,
                field: 'supplierName',
                filterParams: {textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces},
                hide: false,
                headerName: 'Supplier',
                sortable: true,
                filter: 'agTextColumnFilter',
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab']
            },
            {
                minWidth: 150,
                field: 'full_name',
                filterParams: {textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces},
                hide: false,
                headerName: 'Name',
                filter: 'agTextColumnFilter',
                sortable: true,
                suppressColumnsToolPanel: true,
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab']
            },
            {
                minWidth: 120,
                field: 'title',
                filterParams: {textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces},
                hide: false,
                headerName: 'Title',
                sortable: true,
                filter: 'agTextColumnFilter',
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab']
            },
            {
                minWidth: 180,
                field: 'email',
                filterParams: {textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces},
                hide: false,
                headerName: 'Email',
                sortable: true,
                filter: 'agTextColumnFilter',
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab']
            },
            {
                minWidth: 120,
                field: 'phone_number',
                filterParams: {textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces},
                hide: false,
                headerName: 'Phone',
                sortable: true,
                filter: 'agTextColumnFilter',
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab']
            },
            {
                minWidth: 100,
                field: 'status',
                type: 'centerColumn',
                filterParams: {textFormatter: txtFormatter, textCustomComparator: trimWhiteSpaces},
                hide: false,
                headerName: 'Status',
                sortable: true,
                filter: 'agTextColumnFilter',
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'],
                cellRenderer: (params) => {
                    if (!params.value) return ''
                    var ob = document.createElement('div')
                    ob.innerHTML = `<b-button class="status-btn mx-auto">
                        <span style="background: ${_findObj(SITE_STATUS, params.value, 'value', 'color')}; width: 98px;
                        font-size: 0.75rem;font-weight: 400;font-family: Rubik,sans-serif!important;" class="badge badge-secondary h6 py-2 px-3">
                            ${_findObj(SITE_STATUS, params.value)}
                        </span>
                    </b-button>`
                    return ob
                }
            },
            {
                minWidth: 150,
                field: 'responsestatus',
                type: 'centerColumn',
                valueFormatter: (params) => {
                    const value = params.value
                    if (value === null || value === undefined || value === '' || value === '<Blank>') return '<Blank>'
                    return value
                },
                filterParams: {
                    values: ['Opened', 'NA', 'Error', 'Sent', 'Delivered', '<Blank>'],
                    valueFormatter: params => {
                        if (params.value == 'NA') return 'NA'
                        if (params.value == null || params.value === undefined || params.value === '' || params.value === '<Blank>') return '<Blank>'
                        return params.value
                    }
                },
                hide: false,
                headerName: 'Last Contact Result',
                sortable: true,
                filter: 'agSetColumnFilter',
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'],
                cellRenderer: (params) => {
                    if (params.value === null || params.value === undefined || params.value === '' || params.value === '<Blank>') return ''
                    const isError = params.value === EMAIL_STATUS.ERROR[0].toUpperCase() + EMAIL_STATUS.ERROR.slice(1).toLowerCase()
                    var ob = document.createElement('div')
                    if (isError) {
                        ob.innerHTML = `<b-button class="status-btn mx-auto" onclick="window.viewErrorModal && window.viewErrorModal(${params.data.supplier_contactid})" style="cursor: pointer;">
                            <span style="background: ${_findObj(SUPLLIER_EMAIL_STATUS, params.value, 'value', 'color')}; width: 98px;
                            font-size: 0.75rem;font-weight: 400;font-family: Rubik,sans-serif!important;" class="badge badge-secondary h6 py-2 px-3 user-status">
                                ${_findObj(SUPLLIER_EMAIL_STATUS, params.value)}
                            </span>
                        </b-button>`
                    } else {
                        ob.innerHTML = `<b-button class="status-btn mx-auto">
                            <span style="background: ${_findObj(SUPLLIER_EMAIL_STATUS, params.value, 'value', 'color')}; width: 98px;
                            font-size: 0.75rem;font-weight: 400;font-family: Rubik,sans-serif!important;" class="badge badge-secondary h6 py-2 px-3 user-status">
                                ${_findObj(SUPLLIER_EMAIL_STATUS, params.value)}
                            </span>
                        </b-button>`
                    }
                    return ob
                }
            },
            {
                minWidth: 160,
                field: 'emailsentdatetime',
                hide: false,
                headerName: 'Timestamp',
                sortable: true,
                filter: 'agDateColumnFilter',
                filterParams: {
                    browserDatePicker: true,
                    minValidYear: 2010,
                    maxValidYear: 2030,
                    filterOptions: ['equals', 'notEqual', 'lessThan', 'greaterThan', 'inRange', 'blank', 'notBlank'],
                    defaultOption: 'equals'
                },
                menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'],
                cellRenderer: (params) => {
                    const originalValue = params.data?.emailsentdatetime_original
                    const displayValue = params.value || originalValue
                    if (!displayValue || displayValue === '0001-01-01T00:00:00' || displayValue === '1900-01-01T00:00:00')
                        return ''
                    return toLocal(displayValue, { inputFormat: 'YYYY-MM-DDTHH:mm:ss', outputFormat: OUTPUT_SHORTDATE_FORMAT })
                }
            },
            {
                minWidth: 80,
                field: 'action',
                type: 'centerColumn',
                hide: false,
                headerName: 'Action',
                suppressMenu: true,
                suppressSorting: true,
                suppressColumnsToolPanel: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    let eGui = document.createElement('div')
                    eGui.innerHTML = `<div>
                        <i class="fas fa fa-ellipsis-v actionBtn" data-action="open" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" data-action="edit" data-id="${params.data.supplier_contactid}">
                                <i class="far fa-edit mr-2"></i>Edit
                            </a>
                            <a class="dropdown-item" data-action="delete" data-id="${params.data.supplier_contactid}">
                                <i class="far fa-trash-alt mr-2"></i>Delete
                            </a>
                        </div>
                    </div>`
                    return eGui
                }
            }
        ]
    },
    mounted() {
        // Setup global window function for error modal (still needed for responsestatus cell renderer)
        window.viewErrorModal = (id) => {
            const item = this.items.find(i => i.supplier_contactid === id)
            if (item) {
                this.ViewErrorModal(item)
            }
        }
    },
    created()
    {
        this.organization_id = getOrgId()
        this.getAutoNotifySetting()
    },
    beforeDestroy() {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer)
        }
    },

    computed: {
        currentUserId() {
            return this.$store.state.user.id ? this.$store.state.user.id : -1
        }
    },
    methods: {
        onCellClicked(params) {
            if (params.column.colId === 'action') {
                if (params.event.target.dataset.action === 'edit') {
                    const id = parseInt(params.event.target.dataset.id)
                    const item = this.items.find(i => i.supplier_contactid === id)
                    if (item) {
                        this.updateSupplierContacts(item)
                    }
                }
                if (params.event.target.dataset.action === 'delete') {
                    const id = parseInt(params.event.target.dataset.id)
                    const item = this.items.find(i => i.supplier_contactid === id)
                    if (item) {
                        this.deleteSupplierContacts(item, null)
                    }
                }
                return
            }
        },
        headerChangeCallback(checkedAll) {
            this.gridApi.forEachNode((node) => node.setSelected(checkedAll))
        },
        saveState(params) {
            if (this.table_Connection_Data && this.table_Connection_Data.Provider_Login) {
                this.table_Connection_Data.Provider_Login.SupplierContacts_Headers = params.columnApi.getColumnState()
                localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            }
        },
        applyState(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var columnState = tableState?.Provider_Login?.SupplierContacts_Headers
            if (columnState) {
                params.columnApi.applyColumnState({ state: columnState, applyOrder: true })
            }
        },
        onFilterChanged(event) {
            if (this.table_Connection_Data && this.table_Connection_Data.Provider_Login) {
                this.table_Connection_Data.Provider_Login.SupplierContacts_Filters = event.api.getFilterModel()
                localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(this.$store.state.CustomizedHeaders))
            }
            this.fetchData(event)
        },
        setFilterModel(params) {
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == this.$store.state.user.id)[0]
            var filterModel = tableState?.Provider_Login?.SupplierContacts_Filters
            if (filterModel) {
                params.api.setFilterModel(filterModel)
            }
        },
        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },
        onSelectionChanged(params) {
            const selectedRows = params.api.getSelectedRows()
            this.Listitems = selectedRows
            this.suppliercontactIds = selectedRows.map(row => row.supplier_contactid.toString())
            if (selectedRows.length > 0 && !this.isEnable) {
                this.isEnable = true
            }
            if (selectedRows.length == 0 && this.isEnable) {
                this.isEnable = false
            }
        },
        extractFilterValues(filterModel) {
            return {
                full_name: filterModel?.full_name?.filter,
                title: filterModel?.title?.filter,
                email: filterModel?.email?.filter,
                phone_number: filterModel?.phone_number?.filter,
                status: filterModel?.status?.values ? filterModel.status.values.join(',') : null,
                responsestatus: filterModel?.responsestatus?.values ? filterModel.responsestatus.values.join(',') : null,
                supplierName: filterModel?.supplierName?.filter,
                emailsentdatetime: filterModel?.emailsentdatetime?.dateFrom ? filterModel.emailsentdatetime.dateFrom.split(' ')[0] : null,
                emailsentdatetimeTo: filterModel?.emailsentdatetime?.dateTo ? filterModel.emailsentdatetime.dateTo.split(' ')[0] : null,
            }
        },
        onCompleted(data) {
            if(data != 'INSERT' && data != 'DELETE' && data != 'UPDATE')
            {
                this.supplierContactedIds = data
            }
            this.Listitems=[]
            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
        },
        onGlobalSearchChange(searchValue) {
            this.search.globalSearch = searchValue
            this.searchQuery.globalSearch = searchValue
            if (this.gridApi) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        },
        onGlobalSearchInput(searchValue) {
            this.globalSearchText = searchValue
            // Debounce the search to avoid too many API calls
            if (this.searchTimer) {
                clearTimeout(this.searchTimer)
            }
            this.searchTimer = setTimeout(() => {
                this.onGlobalSearchChange(searchValue)
            }, 300)
        },
        clearGlobalSearch() {
            this.globalSearchText = ''
            this.onGlobalSearchChange('')
        },
        getContextMenuItems(params) {
            const checkbox = document.getElementById('headerSelectAllcheckbox')
            if (checkbox) checkbox.checked = false
            params.api.deselectAll()
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            that.searchQuery.colId = params.request?.sortModel[0]?.colId
            that.searchQuery.sort = params.request?.sortModel[0]?.sort
            that.search.full_name = params.request?.filterModel?.full_name?.filter
            that.search.title = params.request?.filterModel?.title?.filter
            that.search.email = params.request?.filterModel?.email?.filter
            that.search.phone_number = params.request?.filterModel?.phone_number?.filter
            that.search.status = params.request?.filterModel?.status?.values ? params.request.filterModel.status.values.join(',') : null
            that.search.responsestatus = params.request?.filterModel?.responsestatus?.values ? params.request.filterModel.responsestatus.values.join(',') : null
            that.search.supplierName = params.request?.filterModel?.supplierName?.filter
            that.search.emailsentdatetime = params.request?.filterModel?.emailsentdatetime?.dateFrom ? params.request.filterModel.emailsentdatetime.dateFrom.split(' ')[0] : null
            that.search.emailsentdatetimeTo = params.request?.filterModel?.emailsentdatetime?.dateTo ? params.request.filterModel.emailsentdatetime.dateTo.split(' ')[0] : null
            that.search.filterModel = that.gridApi.getFilterModel()
            const filterValues = this.extractFilterValues(that.gridApi.getFilterModel())
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email
                    const query_param = {
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        search: that.search.globalSearch || that.searchQuery.globalSearch || '',
                        ...that.search,
                        ...filterValues,
                        email: email,
                        organizationId: that.organization_id
                    }
                    const resp = await supplierContactServices.downloadSupplierContactsXLSX(query_param)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    } else {
                        that._showOk('Export failed. Please try again.', {
                            variant: 'danger',
                            title: 'Error',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }

            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        fetchData(params) {
            const checkbox = document.getElementById('headerSelectAllcheckbox')
            if (checkbox) checkbox.checked = false
            params.api.deselectAll()
            this.applyState(params)
            this.setFilterModel(params)
            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi
            const datasource = {
                getRows(params) {
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    that.search.full_name = params.request?.filterModel?.full_name?.filter
                    that.search.title = params.request?.filterModel?.title?.filter
                    that.search.email = params.request?.filterModel?.email?.filter
                    that.search.phone_number = params.request?.filterModel?.phone_number?.filter
                    that.search.status = params.request?.filterModel?.status?.values ? params.request.filterModel.status.values.join(',') : null
                    that.search.responsestatus = params.request?.filterModel?.responsestatus?.values ? params.request.filterModel.responsestatus.values.join(',') : null
                    that.search.supplierName = params.request?.filterModel?.supplierName?.filter
                    that.search.emailsentdatetime = params.request?.filterModel?.emailsentdatetime?.dateFrom ? params.request.filterModel.emailsentdatetime.dateFrom.split(' ')[0] : null
                    that.search.emailsentdatetimeTo = params.request?.filterModel?.emailsentdatetime?.dateTo ? params.request.filterModel.emailsentdatetime.dateTo.split(' ')[0] : null
                    that.search.filterModel = that.gridApi.getFilterModel()
                    supplierContactServices.findSupplierContacts({
                        ...that.searchQuery,
                        sortField: params.request?.sortModel[0]?.colId,
                        sortDirection: params.request?.sortModel[0]?.sort,
                        organizationId: that.organization_id,
                        search: that.search.globalSearch || that.searchQuery.globalSearch || '',
                        ...that.search
                    }).then(resp => {
                        if (!resp.error) {
                            // Process data modifications if needed
                            if(resp.data.d.c && resp.data.d.c.length > 0)
                            {
                                if(that.supplierContactedIds != null && that.supplierContactedIds.length > 0)
                                {
                                    var supList = []
                                    that.supplierContactedIds.forEach((x) => {
                                        supList.push(x.supplierContactId)
                                    })
                                    resp.data.d.c.forEach((x) => {
                                        if(supList.includes(x.supplier_contactid))
                                        {
                                            that.supplierContactedIds.forEach((y) => {
                                                if(x.supplier_contactid == y.supplierContactId)
                                                {
                                                    x.emailsentdatetime = y.emailTime
                                                }
                                            })
                                        }
                                    })
                                    that.supplierContactedIds = []
                                }
                            }
                            const contactsArray = resp.data.d.c
                            // Process null responsestatus values to ensure rows are displayed
                            if(contactsArray && contactsArray.length > 0) {
                                contactsArray.forEach(contact => {
                                    if(contact.responsestatus === null || contact.responsestatus === undefined || contact.responsestatus === '') {
                                        contact.responsestatus = '<Blank>'
                                    }
                                    // Process default/empty dates for proper filtering
                                    if(contact.emailsentdatetime === '0001-01-01T00:00:00' || contact.emailsentdatetime === '1900-01-01T00:00:00') {
                                        contact.emailsentdatetime_original = contact.emailsentdatetime
                                        contact.emailsentdatetime = null
                                    }
                                })
                            }
                            that.total = resp.data.d.t
                            that.items = contactsArray
                            that.getAutoNotifySetting()
                            if(that.total == 0){
                                that.gridApi.showNoRowsOverlay()
                                that.isCheckboxEnable = false
                            }
                            else{
                                that.gridApi.hideOverlay()
                                that.isCheckboxEnable = true
                            }
                            return contactsArray
                        } else {
                            that.total = 0
                            that.items = []
                            that.gridApi.showNoRowsOverlay()
                            that.isCheckboxEnable = false
                            return []
                        }
                    }).then(response => {
                        // Pass both the data and total row count to prevent empty rows
                        const lastRow = that.total <= params.request.endRow ? that.total : -1
                        params.successCallback(response, lastRow)
                    })
                        .catch(error => {
                            console.error(error)
                            params.failCallback()
                        })
                }
            }
            params.api.setServerSideDatasource(datasource)
        },
        getAutoNotifySetting()
        {
            supplierContactServices.getAutoNotifySetting().then(resp => {
                if (!resp.error) {
                    this.autonotifychecked=resp.data.d.isautonotify
                }
            })
        },
        importSupplierContacts() {
            this.suppliercontactImportKey += 1
            this.$nextTick(()=>{
                this.$refs.suppliercontactImport.forceRerenderInsert()
            })
        },
        getautonotifyvalue(value)
        {
            this.autonotifychecked=value
            supplierContactServices.UpdateAutoNotifySetting(this.autonotifychecked).then(resp => {

            })
        },
        addContactEmailClick() {
            this.$nextTick(() => {
                this.$refs.respModal.forceRerenderInsert(this.Listitems)
            })
        },
        addMoreClick() {
            this.supplierContactModelKey += 1
            this.$nextTick(() => {
                this.$refs.supplierContactModel.forceRerenderInsert(this.organization_id)
            })
        },
        updateSupplierContacts(payload, e = null) {
            this.supplierContactModelKey += 1
            this.$nextTick(() => {
                this.$refs.supplierContactModel.forceRerenderUpdate(payload)
            })
            if (e) {
                e.stopPropagation()
            }
        },
        deleteSupplierContacts(item, e) {
            this._showConfirm('Are you sure do you want to delete the contact, this cannot be undone?').then(confirm => {
                if (confirm) {
                    supplierContactServices.deleteSupplierContacts(item.supplier_contactid).then(resp => {
                        if (!resp.error) {
                            this.onCompleted('DELETE')
                        }
                    })
                }
            })
            if (e) {
                e.stopPropagation()
            }
        },
        ViewErrorModal(item) {
            this.errorModalKey += 1
            this.$nextTick(() => {
                this.$refs.errorModal.forceRerenderView(
                    item
                )
            })
        }
    }
}